import styles from './alertIndicator.module.scss'

interface WithStatusDotProps {
  children: React.ReactNode
  hasAlert?: boolean
}

const AlertIndicator: React.FC<WithStatusDotProps> = ({ children, hasAlert = false }) => (
  <div className={styles.indicator}>
    {children}
    {hasAlert && <span className={styles.alertDot} />}
  </div>
)

export default AlertIndicator
